
/**
 * 对密码进行校验处理
 * @param {*} pwd：用户输入的密码
 * @returns 
 */
//  export const checkPwd = (pwd) => {
//   const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![<>`~\,!\/@;:\.#$\_%\|^&*\-()\[?\]=+{}]+$)[\da-zA-Z<>`~\,!\/@;:\.#$\_%\|^&*\-()\[?\]=+{}]/
//   return reg.test(pwd)
// }
/**
 * js正则判断邮箱地址
 * @param {*} email 
 * @returns 
 */
 export const checkEmail = (email) => {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  // const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  return reg.test(email)
 }
export const hasScroll = () => {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
}

/**
 * 校验密码是否正确
 * @param pwd 
 * @returns 
 */
 export const checkPwd = (pwd, count=2) => {
  // eslint-disable-next-line no-useless-escape
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![<>`~\,!\/@;:\.#$\_%\|^&*\-()\[?\]=+{}]+$)[\da-zA-Z<>`~\,!\/@;:\.#$\_%\|^&*\-()\[?\]=+{}]/
  if(count==3) {
    reg =
      /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*{}()=+<>.,;:'"?/|\\`])[\da-zA-Z~!@#$%^&*{}（）=+<>.,;:'"?/|\\`]/;
  }
  return reg.test(pwd)
}
/**
 * 判断是否包含汉字(中文)
 * @param {*} chineseTip 
 * @returns 
 */
 export const isChinese = (chineseTip) => {
  const reg = /\p{Unified_Ideograph}/u
  return reg.test(chineseTip)
}

/**
 * 处理input框类型是number的时候，输入字母e的处理
 * @param {*} evt
 * @returns
 */
 export const handleOnlyNumber = evt => {
  if (!evt || !(evt instanceof Object)) return;
  const inp = evt.target;
  setTimeout(
    function(ele) {
      const val = ele.value;
      const reg = /\D/g;
      ele.value = val.replace(reg, "");
    },
    200,
    inp
  );
};
